/* eslint dot-notation:0 */
(function(angular, _) {
    'use strict';

    angular.module('um').controller('profile.controller', profileController);

    profileController.$inject = ['$scope', '$translate', 'profileService', 'trackingService', 'GUM_CONST',
        'wtNotifications', 'usersService'];

    function profileController($scope, $translate, profileService, trackingService, GUM_CONST, wtNotifications, usersService) {
        this.$onInit = function() {
            return profileService.getProfileUser().then(function(user) {
                $scope.user = user || {};

                usersService.normalizeUser(user);
                $translate.use(_.lowerCase(user.globalAttributes.language));

                $scope.userBackup = angular.copy($scope.user);
                $scope.setLeftClickHandler();
            });
        };

        $scope.retype = {password: ''};
        $scope.oldpassword = { value: '' };
        $scope.listOfEmails = GUM_CONST.emailPattern;
        $scope.passwordPattern = GUM_CONST.passwordPattern;
        $scope.stringValidationPattern = /^[^\s]+/;
        $scope.languageList = GUM_CONST.languages;
        $scope.numberFormatList = GUM_CONST.numberFormats;
        $scope.prospectiveChange = false; // Changes that apply on next login

        $scope.dropdownMapping = {
            key: 'id',
            title: 'title',
            description: 'description',
            active: 'active',
            visible: 'visible'
        };

        $scope.setLeftClickHandler = function() {
            $scope.languageClickHandlers = {
                leftClick: function(index, element) {
                    if ($scope.user.globalAttributes) {
                        $scope.user.globalAttributes.language = element.id;
                    } else {
                        $scope.user.globalAttributes = {language: element.id};
                    }

                    $scope.prospectiveChange = usersService.hasProspectiveChanges($scope.userBackup, $scope.user);
                    $scope.umUserForm.$pristine = !$scope.prospectiveChange;
                }
            };
        };

        $scope.setNumberFormat = function(numberFormat, e) {
            e.preventDefault();
            usersService.setUserNumberFormat($scope.user, numberFormat);

            $scope.prospectiveChange = usersService.hasProspectiveChanges($scope.userBackup, $scope.user);
            $scope.umUserForm.$pristine = !$scope.prospectiveChange;
        };

        $scope.numberFormatMatch = function(format1, format2) {
            return format1.numberFormatSeparator === format2.numberFormatSeparator
                && format1.numberFormatGrouping === format2.numberFormatGrouping;
        };

        $scope.passWordMatchCheck = function() {
            return (!_.isEmpty($scope.user.password) && _.isEmpty($scope.retype.password)) || $scope.retype.password !== $scope.user.password;
        };

        $scope.updateProfile = function() {
            trackingService.action('profile.update');

            let updatedUserObj = angular.copy($scope.user);

            delete updatedUserObj.password;

            if (updatedUserObj.globalAttributes && _.isArray(updatedUserObj.globalAttributes.chartColors)) {
                updatedUserObj.globalAttributes.chartColors = JSON.stringify(updatedUserObj.globalAttributes.chartColors).replace('"', '\"');
            }

            profileService.updateProfile(updatedUserObj)
                .then(function() {
                    // $scope.userBackup.globalAttributes.language = updatedUserObj.globalAttributes.language;
                    $scope.userBackup = angular.copy($scope.user);
                    $scope.prospectiveChange = false;
                    $scope.umUserForm.$pristine = true;

                    wtNotifications.success('MSG.PROFILE_SUCCESSFULLY_UPDATED');
                })
                .catch(function() {
                    wtNotifications.error('MSG.PROFILE_UPDATE_FAILED');
                });
        };

        $scope.updatePassword = function() {
            trackingService.action('profile.update_password');

            $scope.oldPasswordWrong = false;

            if ($scope.user.password !== $scope.retype.password) {
                wtNotifications.error('MSG.USER_PWDS_NO_MATCH');
                return;
            }

            const updatedUserObj = {
                oldPassword: $scope.oldpassword.value,
                password: $scope.user.password
            };

            profileService.updatePassword(updatedUserObj)
                .then(function() {
                    wtNotifications.success('MSG.PASSWORD_SUCCESSFULLY_UPDATED');
                })
                .catch(function(error) {
                    if (error && (error.message === 'warn.subject.oldPassword.notMatch' || error.message === 'warn.subject.password.isBlank')) {
                        $scope.oldPasswordWrong = true;
                    }
                    // TODO: better msg for error
                    wtNotifications.error('MSG.PASSWORD_INVALID');
                });
        };

        $scope.reset = function() {
            trackingService.action('profile.reset');

            $scope.umUserForm.$setPristine();
            $scope.user = angular.copy($scope.userBackup);
            $scope.prospectiveChange = false;
            $scope.oldpassword.value = '';
            $scope.user.password = '';
            $scope.retype.password = '';
        };
    }
})(window.angular, window._);
